import React, { useEffect, useState, useContext } from 'react';
import CheckerContext from './CheckerContext';
import { Link } from 'gatsby';

import Cross from '-!svg-react-loader!../../ui/svgs/icon-cross.svg';
import { ButtonSmall } from '../../ui/Button';
import { Container } from './styles';

const CountryChecker = ({ countries, countryCode, countriesDomain, translations: t }) => {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [isoCode, setIsoCode] = useState(null);
  const [countryName, setCountryName] = useState(null);
  const { context, setContext } = useContext(CheckerContext);
  const closeCountryChecker = () => {
    setContext(false)
    typeof window !== 'undefined' && window.sessionStorage.setItem('hiddenCountryChecker', 'yes');
  };
  const defaultCountry = countries && countries.filter(country => country.code === 'int')[0];

  setContext(context && typeof window !== 'undefined' && window.sessionStorage.getItem('hiddenCountryChecker') != 'yes');

  useEffect(() => {
    const onSuccess = location => {
      const maxmindIsoCode = location.country?.iso_code.toLowerCase();
      const maxmindCountryName = location.country?.names?.[maxmindIsoCode];

      const isoCodeExists =
        countries && countries.filter(country => country.code === maxmindIsoCode).length;

      if (isoCodeExists) {
        setIsoCode(maxmindIsoCode);
        setCountryName(maxmindCountryName);
      } else {
        setIsoCode(defaultCountry.code);
        setCountryName(defaultCountry.title);
      }
    };

    const onError = error => {
      console.log("GeoIP2 can't be loaded");
      // console.log('Error', JSON.stringify(error, undefined, 4));
    };

    typeof geoip2 !== 'undefined' && geoip2 && geoip2.country(onSuccess, onError);
  }, []);

  useEffect(() => {
    if (countries && isoCode && countryCode && countryCode !== isoCode) {
      let redirectionData = countries && countries.filter(country => country.code === isoCode);
      if (!redirectionData.length) {
        /**
         * Lookup for international language (INT) if isoCode does not exists in
         * the internal languages
         */
        redirectionData = countries.filter(country => country.international);
      }

      if (redirectionData.length) {
        const redirectionUrl = redirectionData[0].domain || null;
        setRedirectUrl(redirectionUrl);
        setContext(true);
      }
    }
  }, [isoCode]);

  const internationalDomain = countries.filter(country => country.international)[0];

  return context ? (
    <Container>
      <div className="text">{t.redirectToCountry}</div>
      <div className="buttons">
        <ButtonSmall className="btn" $inverted={true} to={redirectUrl}>
          {isoCode === defaultCountry.code ? t.redirectButtonInt : t.redirectButton} {countryName}
        </ButtonSmall>
        <ButtonSmall
          className="btn"
          secondary={1}
          $inverted={true}
          as={Link}
          to={`${internationalDomain.domain}/${internationalDomain.langcode}/${countriesDomain}`}
          data-gtm-event
          data-gtm-category="navegacion"
          data-gtm-action={'region'}
          data-gtm-label={`${countryName}`}>
          {t.redirectSelect}
        </ButtonSmall>
      </div>
      <div className="close" onClick={() => closeCountryChecker()}>
        <Cross className="svg" />
      </div>
    </Container>
  ) : (
    <></>
  );
};

export default CountryChecker;
